import React from 'react';
import PushPinIcon from '@mui/icons-material/PushPin';
import SplitScreenIcon from '@mui/icons-material/Splitscreen';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CancelIcon from '@mui/icons-material/Cancel';
import { MoreMenu } from 'components/fragment';

type WidgetHeaderProps = {
  programTitle?: string;
  isFixed?: boolean;
  isSplit?: boolean;
  hidePinSplit?: boolean;
  onSplit: () => void;
  onFullColumn: () => void;
  onPin: () => void;
  isFullScreen?: boolean;
  onProgramRemove: ((programId: string) => void) | undefined;
  onProgramFullScreen: ((programId: string) => boolean) | undefined;
  programId: string;
  columnId: string;
  onRemoveColumn: (columnId: string) => void;
};

const WidgetHeader: React.FC<WidgetHeaderProps> = ({
  programTitle,
  onFullColumn,
  onSplit,
  onPin,
  isFixed = false,
  isSplit = false,
  hidePinSplit = false,
  isFullScreen = false,
  onProgramRemove,
  programId,
  columnId,
  onRemoveColumn,
}) => {
  return (
    <div
      className={`w-full flex items-center ${hidePinSplit || isFullScreen ? 'justify-center' : 'justify-between'} bg-white-50 h-[24px] py-4 relative`}>
      {/* Left: Pin Icon */}
      {!hidePinSplit && !isFullScreen && (
        <div className='flex-shrink-0'>
          <PushPinIcon
            className={`${isFixed ? 'text-vulcan-500' : 'text-lynch-400 cursor-pointer'}`}
            onClick={isFixed ? undefined : onPin}
          />
        </div>
      )}
      <div className='flex flex-shrink-0 items-center justify-center'>
        {programTitle ? (
          programTitle
        ) : isFixed ? (
          ''
        ) : (
          <span className={'text-lynch-500'}>Remove column</span>
        )}{' '}
        {(programTitle || !isFixed) && (
          <CancelIcon
            fontSize='small'
            className='text-lynch-500 cursor-pointer ml-4'
            onClick={() => {
              if (onProgramRemove && programId !== 'widget') {
                onProgramRemove(programId);
              } else {
                onRemoveColumn(columnId);
              }
            }}
          />
        )}
      </div>
      {!hidePinSplit && !isFullScreen && (
        <div className='flex-shrink-0'>
          <SplitScreenIcon
            className={`cursor-pointer ${isSplit ? 'text-vulcan-500' : 'text-lynch-400'}`}
            onClick={onSplit}
          />
          <CropSquareIcon
            className={`cursor-pointer ${isSplit ? 'text-lynch-400' : 'text-vulcan-500'}`}
            onClick={onFullColumn}
          />
        </div>
      )}
      {/*<Menu*/}
      {/*  anchorEl={anchorEl}*/}
      {/*  id='account-menu'*/}
      {/*  open={open}*/}
      {/*  onClose={handleClose}*/}
      {/*  onClick={handleClose}*/}
      {/*  slotProps={{*/}
      {/*    paper: {*/}
      {/*      elevation: 0,*/}
      {/*      sx: {*/}
      {/*        overflow: 'visible',*/}
      {/*        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',*/}
      {/*        mt: 1.5,*/}
      {/*        '& .MuiAvatar-root': {*/}
      {/*          width: 32,*/}
      {/*          height: 32,*/}
      {/*          ml: -0.5,*/}
      {/*          mr: 1,*/}
      {/*        },*/}
      {/*        '&::before': {*/}
      {/*          content: '""',*/}
      {/*          display: 'block',*/}
      {/*          position: 'absolute',*/}
      {/*          top: 0,*/}
      {/*          right: 14,*/}
      {/*          width: 10,*/}
      {/*          height: 10,*/}
      {/*          bgcolor: 'background.paper',*/}
      {/*          transform: 'translateY(-50%) rotate(45deg)',*/}
      {/*          zIndex: 0,*/}
      {/*        },*/}
      {/*      },*/}
      {/*    },*/}
      {/*  }}*/}
      {/*  transformOrigin={{ horizontal: 'right', vertical: 'top' }}*/}
      {/*  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>*/}
      {/*  <MenuItem onClick={handleClose}>*/}
      {/*    <div className={'flex w-full justify-between'}>*/}
      {/*      {isFullScreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}*/}
      {/*      <button className='text-white'>*/}
      {/*        {isFullScreen ? (*/}
      {/*          <FullscreenExitIcon*/}
      {/*            fontSize='small'*/}
      {/*            className='text-vulcan-500'*/}
      {/*            onClick={() => onProgramFullScreen && onProgramFullScreen(programId)}*/}
      {/*          />*/}
      {/*        ) : (*/}
      {/*          <OpenInFullIcon*/}
      {/*            fontSize='small'*/}
      {/*            className='text-vulcan-500'*/}
      {/*            onClick={() => onProgramFullScreen && onProgramFullScreen(programId)}*/}
      {/*          />*/}
      {/*        )}*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </MenuItem>*/}
      {/*  <MenuItem onClick={handleClose}>*/}
      {/*    <div className={'flex w-full justify-between'}>*/}
      {/*      Remove Program*/}
      {/*      <button className='text-white'>*/}
      {/*        <CloseIcon*/}
      {/*          fontSize='small'*/}
      {/*          className='text-vulcan-500'*/}
      {/*          onClick={() => onProgramRemove && onProgramRemove(programId)}*/}
      {/*        />*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </MenuItem>*/}
      {/*</Menu>*/}
    </div>
    // <div className='w-full flex items-center bg-white' style={{ height: '24px', margin: '2px' }}>
    //   <PushPinIcon
    //     className={`mr-2 ${isFixed ? 'text-vulcan-500' : 'text-lynch-400 cursor-pointer'}`}
    //     onClick={isFixed ? undefined : onPin}
    //   />
    //   <div className='ml-auto flex space-x-2'>
    //     <SplitScreenIcon
    //       className={`cursor-pointer ${isSplit ? 'text-vulcan-500' : 'text-lynch-400'}`}
    //       onClick={onSplit}
    //     />
    //     <CropSquareIcon
    //       className={`cursor-pointer ${isSplit ? 'text-lynch-400' : 'text-vulcan-500'}`}
    //       onClick={onFullColumn}
    //     />
    //   </div>
    // </div>
  );
};

export default WidgetHeader;
